import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Button } from 'reactstrap'
import { saveAs } from 'file-saver';
import { createNotification } from 'Config/notificationtoast'
import loaderImag from 'Assets/ProfileModule/PepperyMedium.gif'
import envelope from 'Assets/AttendanceModule/envelope.svg'
import download from 'Assets/AttendanceModule/download.svg'
import send from 'Assets/AttendanceModule/send.svg'
import Pdf from '../ClassAttendanceComponent/Pdf'
import CsvView from '../ClassAttendanceComponent/CsvView'
import './PreviewRubricsReport.scss'

const PreviewRubricsReport = (props) => {
    const {
        forwardRubricsReport,
        showPreviewType,
        fileUrl,
        showCsvUrl,
        setShowPreviewType,
        setFileUrl,
        setShowPreview,
        recordFound,
        setRecordFound,
        setUpoadFile,
        history,
        upoadFile
    } = props;

    const [fromEmail, setFromEmail] = useState("");
    const [subject, setSubject] = useState("Rubrics report");
    const [message, setMessage] = useState("");
    const [showEmailComp, setShowEmailComp] = useState(false);
    const [shareFile, setShareFile] = useState("");
    const [isSelected, setIsSelected] = useState(false);
    const [upoadCsvFile, setUpoadCsvFile] = useState();
    const [invelidMessagePass, setInvelidMessagePass] = useState("");
    const emailBtn = ["viewAttPreDiv", recordFound === "Data not found" ? "opacityBtn" : ""]
    const downloadBtn = ["downloadPreDiv", recordFound === "Data not found" ? "opacityBtn" : ""]
    const reportMailDiv = ["reportMailDiv", showEmailComp ? "showFlex" : ""];

    function blobToFile(theBlob, fileName) {
        return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
    }

    const singlePDFDownload = (URl) => {
        const options = {
            method: 'GET',
            baseURL: URl,
        };
        axios(options).then(async responses => {
            if (responses.data.message === "Data not found") {
                setRecordFound(responses.data.message);
                createNotification('error', responses.data.message);
            } else {
                const options = {
                    method: 'GET',
                    baseURL: URl,
                    responseType: 'blob'
                };
                axios(options).then(async responses => {
                    const file = new Blob(
                        [responses.data],
                        { type: 'application/csv' });
                    const myFile = blobToFile(file, "rubricsReport.csv");
                    setUpoadCsvFile(myFile);
                })
            }
        })
            .catch(err => {
                if (err && err.message) {
                    createNotification('error', err.message);
                }
            });
    }

    const reportDownload = () => {
        if (showPreviewType === "pdf") {
            const fileName = `rubricsReport ${new Date()}.pdf`
            saveAs(fileUrl, fileName);

        } else if (showPreviewType === "csv") {
            const fileName = `rubricsReport ${new Date()}.csv`
            saveAs(showCsvUrl, fileName);
        }
    }

    const BackTOHome = () => {
        setShowPreviewType("");
        setFileUrl("");
        setShowPreview(false);
        setRecordFound("");
        setUpoadCsvFile("");
        setUpoadFile("");
    }

    const sendEmail = () => {
        if (fileUrl) {
            if (fromEmail === "") {
                setInvelidMessagePass("Please enter the email Id*")
                return false;
            }
            if (subject === "") {
                setInvelidMessagePass("Please enter the Subject*")
                return false;
            }
            if (message === "") {
                setInvelidMessagePass("Please enter the Message*")
                return false;
            }
            const apiData = {
                toEmailId: fromEmail,
                subject: subject,
                messageBody: message,
                shareFile: upoadFile
            }
            forwardRubricsReport(apiData);
            setShowEmailComp(false);
            setFromEmail("");
            setSubject("Rubrics report");
            setMessage("");
            setInvelidMessagePass("");
        } else {
            if (fromEmail === "") {
                setInvelidMessagePass("Please enter the email Id*")
                return false;
            }
            if (subject === "") {
                setInvelidMessagePass("Please enter the Subject*")
                return false;
            }
            if (message === "") {
                setInvelidMessagePass("Please enter the Message*")
                return false;
            }
            const apiData = {
                toEmailId: fromEmail,
                subject: subject,
                messageBody: message,
                shareFile: upoadCsvFile
            }
            forwardRubricsReport(apiData);
            setShowEmailComp(false);
            setFromEmail("");
            setSubject("Rubrics report");
            setMessage("");
            setInvelidMessagePass("");
        }
    }

    const ViewEmailComposer = () => {
        setShowEmailComp(true);
    }

    const HideEmailComposer = () => {
        setShowEmailComp(false);
        setFromEmail("");
        setSubject("Rubrics report");
        setMessage("");
        setInvelidMessagePass("");
    }

    return (
        <div className={"PreviewAttContainer"}>
            <div className='ClassAttendanceMainDiv'>
                <div className='classAttendaceDetailsMain'>
                    <div className='rubClassBackDiv'
                        onClick={BackTOHome}
                    >
                        <i className='attClassBackIcon material-icons'>chevron_left</i>
                        {/* <p className='attClassBactText'>Rubrics</p> */}
                    </div>
                    <div className='RubricSeprator'></div>
                    <div className='attClassDetailTextDiv'>
                        {<div className='displayFlexClassRoster'>
                            <div className='headingForEdited'>
                                <p className='attClassName'>Rubrics Report</p>
                            </div>
                            <p className='attClassPreGrades'> - {showPreviewType.toUpperCase()}</p>
                        </div>}
                    </div>
                </div>
                <div className='buttonMarginTop'>
                    <Button className={emailBtn.join(' ')}
                        onClick={recordFound === "Data not found" ? "" : ViewEmailComposer}
                    >
                        <img className='viewAttIcons' src={envelope} alt='' />
                        <span className='viewAttText'> Email </span>
                    </Button>

                    <Button className={downloadBtn.join(' ')}
                        onClick={recordFound === "Data not found" ? "" : reportDownload}
                    >
                        <img className='viewAttIcons' src={download} alt='' />
                        <span className='viewAttText'> Download </span>
                    </Button>
                </div>
            </div>
            {!fileUrl && showPreviewType === "pdf" && !recordFound === "Data not found" && (
                <div>
                    <img src={loaderImag} alt='' className='loaderIconCss' />
                </div>
            )}
            <div className={reportMailDiv.join(' ')}>
                <div className="reportPreView">
                    {showPreviewType === "pdf" && fileUrl && <Pdf fileUrl={fileUrl} />}
                    {showPreviewType === "csv" && showCsvUrl && <CsvView showCsvUrl={showCsvUrl} />}
                </div>
                {recordFound === "Data not found" ? (
                    <div>
                        <p className='noneStudents'>Data not found</p>
                    </div>
                ) : (
                    ''
                )}
                {showEmailComp && <div className='emailComposer'>
                    <div className="titleDiv"><p className="composeTitle">Email Composer</p></div>
                    <form method="post" action="#" className="emailForm">

                        <div className="field">
                            <input type="text" className='mailDiv' name="email" placeholder="To" id="email" value={fromEmail} onChange={e => setFromEmail(e.target.value)} />
                            {invelidMessagePass === "Please enter the email Id*" ? <p className="errormessageRegisters">{invelidMessagePass}</p> : ""}
                        </div>
                        <div className="field">
                            <textarea name="message" className="subjectText" id="message" rows="4" value={subject} onChange={e => setSubject(e.target.value)}
                                placeholder="Subject"></textarea>
                            {invelidMessagePass === "Please enter the Subject*" ? <p className="errormessageRegisters">{invelidMessagePass}</p> : ""}
                        </div>
                        <div className="field">
                            <textarea name="message" className="messageText" id="message" rows="4" value={message} onChange={e => setMessage(e.target.value)}
                                placeholder="Enter Message.."></textarea>
                            {invelidMessagePass === "Please enter the Message*" ? <p className="errormessageRegisters">{invelidMessagePass}</p> : ""}
                        </div>
                    </form>
                    <div className="actions">
                        <Button className='cancelBtn'
                            onClick={HideEmailComposer}
                        >
                            <span className='cancelText'> Cancel </span>
                        </Button>
                        <Button className='emailBtn'
                            onClick={sendEmail}
                        >
                            <img className='viewAttIcons' src={send} alt='' />
                            <span className='viewAttText'> Send </span>
                        </Button>
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default PreviewRubricsReport;